export default __webpack_public_path__ + "static/media/information--pedestrians-only--g4.6947b95d.png";